import SectionHeading from "./SectionHeading";

const cases = [
  {
    img: "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20official%20penalty%20notice%20and%20account%20suspension%20on%20short%20video%20platform%2C%20gavel%20and%20documents%20on%20warm%20desk%20with%20red%20seal%20stamp%2C%20clean%20minimal%20newsroom%20style%2C%20soft%20warm%20lighting%2C%20beige%20background%2C%20no%20real%20faces%2C%20high%20detail%20photography&width=800&height=520&seq=penalty-case-01&orientation=landscape",
    alt: "官方处罚案例封面图",
    date: "08-28",
    penalty: "限流处置",
    level: "较重",
    title: "「流量异常增长」账号批量限流，判定口径引质疑",
    body: "平台公告对一批账号施以限流与功能冻结，理由是数据异常。处罚依据如何界定、有无申诉通道，成为创作者最关心的问题。",
    counts: { view: "3.2万", comment: "840" },
  },
  {
    img: "https://readdy.ai/api/search-image?query=Editorial%20photo%20style%20of%20live%20streaming%20penalty%20and%20compliance%20enforcement%2C%20warning%20signs%20and%20smartphone%20on%20table%20with%20dark%20red%20accents%2C%20documentary%20minimal%20layout%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20no%20people%2C%20high%20detail&width=800&height=520&seq=penalty-case-02&orientation=landscape",
    alt: "直播处置案例封面图",
    date: "08-19",
    penalty: "直播封禁",
    level: "严重",
    title: "直播专项治理：一批账号被分级处置",
    body: "针对直播内容违规，平台开启专项治理。处置名单与阶梯规则同步更新，是否「一刀切」成为评论区反复争论的焦点。",
    counts: { view: "5.6万", comment: "2100" },
  },
  {
    img: "https://readdy.ai/api/search-image?query=Conceptual%20image%20about%20algorithm%20penalty%20and%20recommendation%20downgrade%20on%20short%20video%20app%2C%20chart%20and%20phone%20in%20warm%20neutral%20palette%20with%20crimson%20highlight%2C%20minimal%20news%20magazine%20aesthetic%2C%20soft%20shadow%2C%20no%20face%2C%20detailed&width=800&height=520&seq=penalty-case-03&orientation=landscape",
    alt: "算法处罚案例封面图",
    date: "08-11",
    penalty: "降权处置",
    level: "中等",
    title: "推荐位「降权」机制被点名，流量下滑是惩罚还是算法？",
    body: "多位创作者反馈流量骤降并怀疑被降权。平台称是内容质量模型调整所致，双方对「黑箱算法」的解释存在明显分歧。",
    counts: { view: "1.9万", comment: "460" },
  },
];

export default function PenaltyFlow() {
  return (
    <section id="penalty" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            kicker="官方处罚案例索引"
            title="官方处罚 · 争议追踪"
            desc="从限流、降权到直播封禁，按处置口径归档平台公告与创作者反馈，梳理每一起处罚背后的判定逻辑。"
            accent
          />
          <a
            href="#timeline"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            查看完整时间线
            <i className="ri-arrow-right-up-line" />
          </a>
        </div>

        <div className="mt-8 grid w-full grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {cases.map((c) => (
            <article
              key={c.title}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="relative overflow-hidden bg-background-200">
                <img
                  src={c.img}
                  alt={c.alt}
                  className="h-52 w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute left-3 top-3 flex items-center gap-1.5">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                    <i className="ri-error-warning-line" /> {c.penalty}
                  </span>
                </div>
                <span className="absolute right-3 top-3 inline-flex items-center whitespace-nowrap rounded-full bg-foreground-950/70 px-2 py-1 text-[11px] text-background-50 backdrop-blur">
                  处置等级 · {c.level}
                </span>
                <span className="absolute bottom-3 left-3 rounded bg-background-50/85 px-2 py-0.5 text-[11px] font-medium text-foreground-800 backdrop-blur">
                  {c.date}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-label text-[15px] font-semibold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {c.title}
                </h3>
                <p className="mt-2 flex-1 text-[13px] leading-relaxed text-foreground-600">{c.body}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-3">
                    <span className="inline-flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-eye-line" /> {c.counts.view}
                    </span>
                    <span className="inline-flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-chat-3-line" /> {c.counts.comment}
                    </span>
                  </span>
                  <span className="whitespace-nowrap text-primary-600">去讨论 →</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}